var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrophoneStage = function SvgIconMicrophoneStage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.796 3.296q.044-.043.09-.08a7 7 0 0 1 9.897 9.9 1 1 0 0 1-.167.167 6.98 6.98 0 0 1-5.527 1.936l-9.478 6.95a1.74 1.74 0 0 1-2.28-.175L2.005 20.67a1.74 1.74 0 0 1-.175-2.28l6.95-9.478a6.977 6.977 0 0 1 1.935-5.526 1 1 0 0 1 .08-.09m4.954-.046c-1.02 0-1.967.305-2.758.828l6.93 6.93A5 5 0 0 0 15.75 3.25m-4.927 5.854a1 1 0 0 0-.025-.159 4.976 4.976 0 0 1 .78-3.453l6.93 6.93a4.98 4.98 0 0 1-3.458.78 1 1 0 0 0-.15-.024 5.005 5.005 0 0 1-4.077-4.074m-1.35 2.247-5.905 8.052 1.03 1.03 8.052-5.905a7.03 7.03 0 0 1-3.178-3.177",
    clipRule: "evenodd"
  })));
};
export default SvgIconMicrophoneStage;